import React, { createContext } from 'react';
import { envConfigs } from './config';
export var ConfigContext = createContext(null);
ConfigContext.displayName = 'ConfigContext';

function ConfigProvider(_ref) {
  var children = _ref.children,
      env = _ref.env;

  if (!envConfigs.hasOwnProperty(env)) {
    throw new Error("Property env: ".concat(env, " is not defined in envConfigs!"));
  }

  return React.createElement(ConfigContext.Provider, {
    value: envConfigs[env]
  }, children);
}

function useConfig() {
  var context = React.useContext(ConfigContext);

  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigContext');
  }

  return context;
}

export { ConfigProvider, useConfig };